/** Tier-1 + tier-2 web control lane budgets (15s each for play_uri). */
const PLAY_URI_WEB_LANE_TIMEOUT_MS = 15_000;

/** Tier-4 connector invoke ceiling when postMessage fallback is active. */
const PLAY_URI_CONNECTOR_INVOKE_TIMEOUT_MS = 45_000;

/** Headroom after ladder exhaustion before queue gives up (#653 Lars-class device test). */
const PLAY_URI_TIMEOUT_HEADROOM_MS = 5_000;

/** playUri queue timeout: web lanes + connector invoke + headroom. */
export function playUriTransportCommandTimeoutMs(): number {
  return PLAY_URI_WEB_LANE_TIMEOUT_MS * 2
    + PLAY_URI_CONNECTOR_INVOKE_TIMEOUT_MS
    + PLAY_URI_TIMEOUT_HEADROOM_MS;
}
